import { FieldModel } from '@cibo/core'
import { FieldColumnProps } from '@cibo/landmanager'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { FieldStatusChipProps, FieldStatusChips } from '../FieldStatusChips'

export type FieldStatusColumnProps = FieldColumnProps &
  Pick<
    FieldStatusChipProps,
    'onClickEnrolling' | 'onClickEngaged' | 'onClickNeedsInfo' | 'onClickProgram'
  >

export const fieldStatusColumn = ({
  onClickNeedsInfo,
  onClickEnrolling,
  onClickEngaged,
  onClickProgram,
  t,
  ...columnProps
}: FieldStatusColumnProps) => ({
  field: 'status',
  headerName: t('status'),
  resizable: true,
  sortable: false,
  filterable: false,
  renderCell: (params: GridRenderCellParams<any, FieldModel>) => (
    <FieldStatusChips
      field={params.row}
      onClickEnrolling={onClickEnrolling}
      onClickEngaged={onClickEngaged}
      onClickProgram={onClickProgram}
      onClickNeedsInfo={onClickNeedsInfo}
    />
  ),
  ...columnProps,
})
